import { ContactType, PatientListDto } from '@lmt/shared-types';

export const patientContactFields = <const>[
  'mobilePhone',
  'homePhone',
  'workPhone',
  'email',
  'fax',
];

export type PatientContacts = {
  [Key in typeof patientContactFields[number]]?: PatientListDto[Key];
};

export function getContactTypeFromField(field: string) {
  switch (field) {
    case 'mobilePhone':
      return ContactType.MobilePhone;
    case 'homePhone':
      return ContactType.HomePhone;
    case 'workPhone':
      return ContactType.WorkPhone;
    case 'email':
      return ContactType.Email;
    case 'fax':
      return ContactType.Fax;
    default:
      return ContactType.Undefined;
  }
}
